<template>
  <div class="gap-2 flex flex-wrap h-full text-white">
    <a
      @click="dispatchQuickAction(action)"
      class="cursor-pointer py-2 px-4 flex flex-col bg-gray-200 bg-opacity-20 rounded-md font-bold flex-1 text-xs"
      v-for="action in suggestedActions.actions">
      <div v-if="action.icon" class="w-full py-2">
        <i class="fa fa-2x" :class="action.icon" style="max-width: 120px" />
      </div>
      <img
        v-if="action.image"
        :src="action.image"
        class="mx-auto flex-grow block w-auto h-auto object-contain"
        style="max-width: 120px; max-height: 95px"
        alt="action" />
      <br v-if="action.image" />

      {{ action.title }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'QuickActionsCell',
  props: {
    suggestedActions: {
      type: Object,
      default: () => {
        return { actions: [{ title: 'title', value: 'value', type: 'imBack' }] }
      }
    }
  },
  data() {
    return {
      respondedToQuickAction: false
    }
  },
  methods: {
    dispatchQuickAction(action) {
      this.respondedToQuickAction = true
      if (action.type === 'imBack') this.$store.dispatch('chatModule/sendChatMessage', action.value)
      if (action.type === 'openUrl') window.open(action.value)
    }
  }
}
</script>
